import {
  Button,
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Checkbox,
  Divider,
} from "@mui/material";
import { useCallback, useEffect, useState, useRef } from "react";
import { makeStyles } from "@mui/styles";
import { rem, goPush } from "assets/js/common";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { stepAction, setUserAction } from "redux/reducers/join";
import { useParams, useHistory } from "react-router-dom";
import ProvisionPopup from "./provision-popup";

const useStyles = makeStyles((theme) => ({
  agreeCont: {
    "& .MuiDivider-root": {
      marginTop: rem(20),
      marginBottom: rem(30),
    },
    "& .marketing-check": {
      justifyContent: "start",
      margin: `${rem(16)} 0 0 ${rem(35)}`,
    },
    "& .MuiFormHelperText-root": {
      marginTop: rem(14),
    },

    "& .MuiFormGroup-row": {
      "& .MuiFormControlLabel-root": {
        marginTop: "0 !important",
        marginBottom: rem(10),
        "&:not(:last-of-type)": {
          margin: `0 ${rem(26)} ${rem(10)} 0}`,
        },
      },
    },
    "& .MuiFormControlLabel-root": {
      "& .MuiButtonBase-root": {
        margin: `0 ${rem(15)} 0 0`,
      },
    },
    "& .MuiFormControl-root": {
      "& .MuiFormControlLabel-root": {
        "& + .MuiFormControlLabel-root": {
          marginTop: rem(16),
        },
      },
    },
  },
}));

export default function JoinStep2(props) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.join);
  const history = useHistory();
  let { seq } = useParams();
  const [tp, setTp] = useState("");

  const classes = useStyles();
  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      allYn: false,
      tncYn: false, // 약관동의여부
      plcyYn: false, // 개인정보동의여부
      mktYn: false,
      mktSmsYn: false, // 마케팅SMS수신여부
      mktPushYn: false, // 마케팅PUSH수신여부
      mktEmailYn: false, // 마케팅EMAIL수신여부
      // gnrPushYn: false, //
    },
  });

  const handleChangeAll = (e) => {
    let value = e.target.checked;
    setValue("allYn", value);
    setValue("tncYn", value, {
      shouldValidate: true,
    });
    setValue("plcyYn", value, {
      shouldValidate: true,
    });
    setValue("mktYn", value);
    setValue("mktSmsYn", value);
    setValue("mktPushYn", value);
    setValue("mktEmailYn", value);
    // setValue("gnrPushYn", value);
  };

  watch("allYn", false);
  watch("tncYn", false);
  watch("plcyYn", false);
  watch("mktYn", false);
  watch("mktSmsYn", false);
  watch("mktPushYn", false);
  watch("mktEmailYn", false);
  // watch("gnrPushYn", false);

  const handleChange = (e) => {
    let name = e.target.name;
    console.log(typeof e.target.checked);
    setValue(name, e.target.checked, {
      shouldValidate: true,
    });

    if (name == "mktYn") {
      setValue("mktSmsYn", e.target.checked);
      setValue("mktPushYn", e.target.checked);
      setValue("mktEmailYn", e.target.checked);
      // setValue("gnrPushYn", e.target.checked);
    }

    if (
      !getValues("mktSmsYn") &&
      !getValues("mktPushYn") &&
      !getValues("mktEmailYn")
      // && !getValues("gnrPushYn")
    ) {
      setValue("mktYn", false);
    } else {
      setValue("mktYn", true);
    }

    if (getValues("tncYn") && getValues("plcyYn") && getValues("mktYn")) {
      setValue("allYn", true);
    } else {
      setValue("allYn", false);
    }
  };

  const checkButton = !(getValues("tncYn") && getValues("plcyYn"));

  const onSubmit = (data) => {
    for (let key in data) {
      data[key] = data[key] ? "Y" : "N";
    }

    dispatch(
      setUserAction({
        ...user,
        ...data,
      })
    );
    dispatch(stepAction(3));
    history.push("/join/3");
  };

  const [open, setOpen] = useState(false);
  const handlePopupClose = () => {
    setOpen(false);
  };

  const handlePopupOpen = (e, tp) => {
    e.preventDefault();
    setTp(tp);
    setOpen(true);
  };

  const onReset = () => {
    reset({
      allYn: user.tncYn == "Y" && user.plcyYn == "Y" && user.mktYn == "Y",
      tncYn: user.tncYn == "Y" ? true : false,
      plcyYn: user.plcyYn == "Y" ? true : false,
      mktYn:
        user.mktSmsYn == "Y" &&
        user.mktEmailYn == "Y" &&
        // user.gnrPushYn == "Y" &&
        user.mktPushYn == "Y",
      mktSmsYn: user.mktSmsYn == "Y" ? true : false,
      mktEmailYn: user.mktEmailYn == "Y" ? true : false,
      // gnrPushYn: user.gnrPushYn == "Y" ? true : false,
      mktPushYn: user.mktPushYn == "Y" ? true : false,
    });
  };

  useEffect(() => {
    onReset();
    goPush();
    // app return
    // app push
    window.appPushInfoHandle = (data) => {
      dispatch(
        setUserAction({
          ...user,
          pushYn: data ? "Y" : "N",
        })
      );
    };
  }, []);

  window.appBackKeyHandle = () => {
    if (open) {
      handlePopupClose();
    } else {
      history.goBack();
    }
  };

  const children = (
    <>
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            name="tncYn"
            icon={<span className="checkbox-icon" />}
            checkedIcon={<span className="checkbox-icon-checked" />}
            className="underline"
            {...register("tncYn", {
              required: true,
            })}
            checked={getValues("tncYn")}
            onChange={handleChange}
          />
        }
        label={
          <span className="font-14" onClick={(e) => handlePopupOpen(e, 2)}>
            [필수] 이용약관 동의
          </span>
        }
      />
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            name="plcyYn"
            icon={<span className="checkbox-icon" />}
            checkedIcon={<span className="checkbox-icon-checked" />}
            className="underline"
            {...register("plcyYn", {
              required: true,
            })}
            checked={getValues("plcyYn")}
            onChange={handleChange}
          />
        }
        label={
          <span className="font-14" onClick={(e) => handlePopupOpen(e, 1)}>
            [필수] 개인정보 수집 및 이용
          </span>
        }
      />
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            name="mktYn"
            icon={<span className="checkbox-icon" />}
            checkedIcon={<span className="checkbox-icon-checked" />}
            // className="underline"
            {...register("mktYn")}
            checked={getValues("mktYn")}
            onChange={handleChange}
          />
        }
        label={<span className="font-14">[선택] 마케팅 정보 수신</span>}
      />

      <FormGroup row className="marketing-check">
        <FormControlLabel
          value="sms"
          control={
            <Checkbox
              color="primary"
              name="mktSmsYn"
              icon={<span className="checkbox-icon" />}
              checkedIcon={<span className="checkbox-icon-checked" />}
              className="noborder"
              {...register("mktSmsYn")}
              checked={getValues("mktSmsYn")}
              onChange={handleChange}
            />
          }
          label={<span className="font-14">SMS</span>}
        />
        <FormControlLabel
          value="email"
          control={
            <Checkbox
              color="primary"
              name="mktEmailYn"
              icon={<span className="checkbox-icon" />}
              checkedIcon={<span className="checkbox-icon-checked" />}
              className="noborder"
              {...register("mktEmailYn")}
              checked={getValues("mktEmailYn")}
              onChange={handleChange}
            />
          }
          label={<span className="font-14">이메일</span>}
        />
        {/* <FormControlLabel
          value="email"
          control={
            <Checkbox
              color="primary"
              name="gnrPushYn"
              icon={<span className="checkbox-icon" />}
              checkedIcon={<span className="checkbox-icon-checked" />}
              className="noborder"
              {...register("gnrPushYn")}
              checked={getValues("gnrPushYn")}
              onChange={handleChange}
            />
          }
          label={<span className="font-14">일반 PUSH</span>}
        /> */}
        <FormControlLabel
          value="push"
          control={
            <Checkbox
              color="primary"
              name="mktPushYn"
              icon={<span className="checkbox-icon" />}
              checkedIcon={<span className="checkbox-icon-checked" />}
              className="noborder"
              {...register("mktPushYn")}
              checked={getValues("mktPushYn")}
              onChange={handleChange}
            />
          }
          label={<span className="font-14">광고성 PUSH</span>}
        />
      </FormGroup>
    </>
  );

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="layout-flex">
          <div className={"layout-body join-body " + classes.agreeCont}>
            <h3 className="h3">약관 동의를 진행해주세요.</h3>

            <Box mt={10}>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      name="allYn"
                      icon={<span className="checkbox-icon" />}
                      checkedIcon={<span className="checkbox-icon-checked" />}
                      {...register("allYn")}
                      checked={getValues("allYn")}
                      onChange={handleChangeAll}
                    />
                  }
                  label={<b>모두 동의하기</b>}
                />
                <Divider style={{ marginTop: rem(16) }} />
                {children}

                {(errors.tncYn?.type === "required" ||
                  errors.plcyYn?.type === "required") && (
                  <FormHelperText id="error-text" className="error">
                    필수 동의 영역을 체크해주세요.
                  </FormHelperText>
                )}
              </FormControl>
            </Box>
          </div>

          <div className="layout-footer">
            <div className="layout-link">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={checkButton}
              >
                다음
              </Button>
            </div>
          </div>
        </div>
      </form>
      <ProvisionPopup open={open} tp={tp} handlePopupClose={handlePopupClose} />
    </>
  );
}
